import { useState } from "react";

import { queryClient, QueryKeys, useEntities } from "@/api/core";
import { accountSchema } from "@/schemas";

interface Params {
  endpoint: "followers" | "following";
  mutual?: boolean;
  verified?: boolean;
}

function useUserConnections(accountId: string | undefined, params: Params) {
  const [mutualFollowersCount, setMutualFollowersCount] = useState(0);

  const { queries } = queryClient.getDefaultOptions();

  const queryInfo = useEntities({
    queryKey: QueryKeys.accounts.connections(accountId!, params),
    endpoint: `/api/v2/accounts/${accountId}/${params.endpoint}`,
    params: {
      mutual: params.mutual ?? false,
      verified: params.verified ?? false,
    },
    getTotalCount(totalCount) {
      if (params.mutual) {
        setMutualFollowersCount(totalCount);
      }
    },
    refetchOnMount: params.mutual,
    staleTime: params.mutual ? 0 : queries?.staleTime,
    schema: accountSchema,
    enabled: !!accountId,
    relationshipConfig: {
      category: "account",
    },
  });

  return {
    ...queryInfo,
    mutualFollowersCount,
    accounts: queryInfo.entities,
  };
}

export { useUserConnections };
